import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-35c59639"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  class: "gap-x-20",
  style: {"display":"flex"}
}
const _hoisted_3 = {
  key: 0,
  class: "tips gap-y-10"
}
const _hoisted_4 = { class: "dialog-main-title" }
const _hoisted_5 = { style: {"color":"var(--el-color-info)"} }
const _hoisted_6 = { style: {"color":"var(--el-color-info)"} }
const _hoisted_7 = {
  key: 1,
  class: "tips gap-y-10"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "dialog-footer" }

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ProcessResult } from '../_enum/process-result'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { RiskItemService } from '../riskItem.service'
import { ElMessage } from 'element-plus'
import { IS_PRIVATE } from '@/common/const/env'


export default /*#__PURE__*/_defineComponent({
  __name: 'HandleRiskItem',
  props: {
  modelValue: {
    type: Boolean,
  },
  single: {
    type: Boolean,
    required: false,
  },
  processType: {
    type: Number as any,
    default: 1
  },
  system_type: {
    type: Number as any,
    default: null
  },
  actionType: {
    type: Number,
    default: 1
  },
  device_id: {
    type: String,
    default: ''
  },
  selectedList: {
    type: Array,
    default: () => []
  },
},
  emits: ['refresh', 'update:modelValue', 'update:single', 'update:actionType'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const injector = useReflectiveInjector([RiskItemService])
const service = injector.get(RiskItemService)
// 处理
const process = service.processRisk.bind(service)
// 添加
const add = service.addTrust.bind(service)
// 恢复
const recoverFile = service.recoverFile.bind(service)
// 移除
const del = service.delTrust.bind(service)
const emit = __emit
const props = __props
// 使用计算属性优化逻辑   /** 系统类型,1-windows,2-linux, 3-Windows server */
const isLinuxSystem = computed(() => (row) => {
  const sysType = row.system_type || props.system_type
  return sysType === 2
})

const isSupportedSystem = computed(() => (row) => {
  const sysType = row.system_type || props.system_type
  if (!IS_PRIVATE) {
    return [1, 2, 3].includes(sysType)
  } else {
    return [1, 2, 3].includes(sysType)
  }
})

const tooltipContent = computed(() => (row) => {
  if (isLinuxSystem.value(row)) {
    return t('safeProtectionModule.tooltipLinuxNoSupport')
  }
  return t('safeProtectionModule.tooltipOsNoSupport')
})

const isTooltipDisabled = (btnType, row) => {
  if (btnType === 'add' && isLinuxSystem.value(row)) {
    return false
  }
  return isSupportedSystem.value(row)
}

const isButtonDisabled = (btnType, row) => {
  if (btnType === 'add' && isLinuxSystem.value(row)) {
    return true
  }
  return !isSupportedSystem.value(row)
}
const visible = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val)
  },
})
const singleFlag = computed({
  get: () => props.single,
  set: (val) => {
    emit('update:single', val)
  },
})
const describeType = computed({
  get: () => props.actionType,
  set: (val) => {
    emit('update:actionType', val)
  },
})
const executeType = ref(0)
const loading = ref(false)
const selectedRow: any = ref({})
const currentRowIndex = ref(-1)
const describeObj = computed(() => ({
  1: {
    describes: [t('safeProtectionModule.riskHandleProcessD1'), t('safeProtectionModule.riskHandleProcessD2')],
  },
  2: {
    describes: [t('safeProtectionModule.riskHandleRecoverD1'), t('safeProtectionModule.riskHandleRecoverD2')],
  },
  3: {
    describes: [t('safeProtectionModule.riskHandleRemoveD1'), t('safeProtectionModule.riskHandleRemoveD2')],
  },
}))
// 弹窗首行文案整句翻译,避免前后缀拼接导致部分语言语序不通
const line1 = computed(() => {
  const count = singleFlag.value ? 1 : props.selectedList.length
  const line1Map = {
    1: t('safeProtectionModule.riskHandleLine1Process', { count }),
    2: t('safeProtectionModule.riskHandleLine1Recover', { count }),
    3: t('safeProtectionModule.riskHandleLine1Remove', { count }),
  }
  return line1Map[describeType.value] || ''
})
// 1,2,4分别表示处理结果的状态
const types = computed<Record<ProcessResult, object>>(() => ({
  1: {
    btns: [{
      name: t('safeProtectionModule.addTrustBtn'), type: 'add', events: (row, index) => ({
        click () {
          selectedRow.value = {}
          singleFlag.value = true
          selectedRow.value = row
          currentRowIndex.value = index
          describeType.value = 4
          visible.value = true
        }
      })
    }, {
      name: t('safeProtectionModule.processNow'), type: 'process', events: (row, index) => ({
        click () {
          singleFlag.value = true
          selectedRow.value = {}
          selectedRow.value = row
          currentRowIndex.value = index
          describeType.value = 1
          visible.value = true
        }
      })
    }]
  },
  2: {
    btns: [{
      name: t('safeProtectionModule.recoverFileBtn'), type: 'recover', events: (row, index) => ({
        click () {
          singleFlag.value = true
          selectedRow.value = {}
          selectedRow.value = row
          currentRowIndex.value = index
          describeType.value = 2
          visible.value = true
        }
      })
    }]
  },
  4: {
    btns: [{
      name: t('safeProtectionModule.removeTrustBtn'), type: 'remove', events: (row, index) => ({
        click () {
          singleFlag.value = true
          selectedRow.value = {}
          selectedRow.value = row
          currentRowIndex.value = index
          describeType.value = 3
          visible.value = true
        }
      })
    }]
  }
}))
// 执行describeType对应的func 1:处理,2:恢复,3:移除,4:添加
const confirm = async () => {
  loading.value = true
  const keys = singleFlag.value ? [selectedRow.value] : props.selectedList
  const params = keys.map((item: any) => ({ md5: item.md5, path: item.path || item.virus_info?.payload?.文件路径, qurant_path: item.qurant_path, device_id: props.device_id || item.device_id, data_type: item.data_type }))
  const actionHandlers = {
    // 处理
    1: async () => await process(params),
    // 恢复
    2: async () => await recoverFile(params),
    // 移除
    3: async () => await del(params),
    // 添加
    4: async () => await add({ execute_type: executeType.value, device_id: props.device_id || selectedRow.value.device_id, path: selectedRow.value.path || selectedRow.value?.virus_info?.payload?.文件路径, md5: selectedRow.value.md5, data_type: selectedRow.value.data_type })
  }
  let ok = true
  await actionHandlers[describeType.value]().catch(() => {
    ok = false
    ElMessage({
      type: 'error',
      message: t('safeProtectionModule.riskCmdFailed'),
    })
  }).finally(() => { loading.value = false })
  if (!ok) return
  visible.value = false
  ElMessage({
    type: 'success',
    message: t('safeProtectionModule.riskCmdSuccess'),
  })
  emit('refresh', currentRowIndex.value)
}
const resetStatus = () => {
  singleFlag.value = true
  currentRowIndex.value = -1
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (types.value[props.processType]?.btns)
      ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          label: _ctx.$t('safeProtectionModule.colOperation'),
          width: 90 * types.value[props.processType || 1]?.btns?.length,
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value[props.processType].btns, (btn) => {
                return (_openBlock(), _createBlock(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: tooltipContent.value(scope.row),
                  disabled: isTooltipDisabled(btn.type, scope.row),
                  placement: "top-start",
                  key: btn.type
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "text",
                      size: "mini",
                      disabled: isButtonDisabled(btn.type,scope.row),
                      link: "",
                      onClick: ($event: any) => (btn.events(scope.row, scope.$index).click())
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(btn.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["content", "disabled"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["label", "width"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      onClose: resetStatus,
      width: "520px"
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.tip')), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            loading: loading.value,
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.submit')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/safe-status/loaris-trojan-remover/_images/modal_tip",
            monochrome: "",
            size: 48,
            color: "var(--cm-color-primary)"
          }),
          (describeType.value === 4)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                _createElementVNode("li", _hoisted_4, _toDisplayString(_ctx.$t('safeProtectionModule.riskTrustScopeTitle')), 1),
                _createElementVNode("li", null, [
                  _createVNode(_component_el_radio_group, {
                    modelValue: executeType.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((executeType).value = $event)),
                    class: "gap-y-10 cm-ui-ml5 cm-ui-mt10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        label: 0,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.trustCurrentOnly')) + " ", 1),
                          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('safeProtectionModule.trustCurrentOnlyHint')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, {
                        label: 2,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.trustAllNetwork')) + " ", 1),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('safeProtectionModule.trustAllNetworkHint')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                _createElementVNode("li", {
                  class: "dialog-main-title",
                  innerHTML: line1.value
                }, null, 8, _hoisted_8),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(describeObj.value[describeType.value].describes, (item, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "dialog-sub-title",
                    key: idx
                  }, _toDisplayString(item), 1))
                }), 128))
              ]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})